import React from 'react'

const BlogArea = () => {
  return (
    <section className="blog-area pt-115 pb-120">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-6 col-lg-8">
          <div className="section-title home-four-title black-title text-center mb-65">
            <h2>Latest News &amp; <span>Articles</span></h2>
            <p>Compete with 100 players on a remote island for winner takes showdown known issue where certain skin strategic</p>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-4 col-md-6 col-sm-9">
          <div className="blog-post home-four-blog-post mb-50">
            <div className="blog-thumb mb-30">
              <a href="/#"><img src="assets/img/blog/home_four_blog_thumb01.jpg" alt="" /></a>
            </div>
            <div className="blog-post-content">
              <div className="blog-meta">
                <ul>
                  <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                  <li><i className="far fa-calendar-alt" />september 19, 2020</li>
                </ul>
              </div>
              <h4><a href="/#">Shooter action video</a></h4>
              <p>Compete with 100 players on a remote island thats winner takes showdown known issue.</p>
              <a href="/blog-details" className="read-more">Read More <i className="fas fa-caret-right" /></a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-9">
          <div className="blog-post home-four-blog-post mb-50">
            <div className="blog-thumb mb-30">
              <a href="/#"><img src="assets/img/blog/home_four_blog_thumb02.jpg" alt="" /></a>
            </div>
            <div className="blog-post-content">
              <div className="blog-meta">
                <ul>
                  <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                  <li><i className="far fa-calendar-alt" />september 19, 2020</li>
                </ul>
              </div>
              <h4><a href="/#">THE WALKING DEAD</a></h4>
              <p>Compete with 100 players on a remote island thats winner takes showdown known issue.</p>
              <a href="/blog-details" className="read-more">Read More <i className="fas fa-caret-right" /></a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-9">
          <div className="blog-post home-four-blog-post mb-50">
            <div className="blog-thumb mb-30">
              <a href="/#"><img src="assets/img/blog/home_four_blog_thumb03.jpg" alt="" /></a>
            </div>
            <div className="blog-post-content">
              <div className="blog-meta">
                <ul>
                  <li><i className="far fa-user" /><a href="/#">Admin</a></li>
                  <li><i className="far fa-calendar-alt" />september 19, 2020</li>
                </ul>
              </div>
              <h4><a href="/#">DEFENSE OF THE ANCIENTS</a></h4>
              <p>Compete with 100 players on a remote island thats winner takes showdown known issue.</p>
              <a href="/blog-details" className="read-more">Read More <i className="fas fa-caret-right" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default BlogArea